<!-- Just a general purpose app-styled button -->
<template>
    <q-btn
        no-caps
        :color="secondary ? 'input' : 'accent'"
        :text-color="secondary ? 'input' : 'white'"
        :to="to"
    >
        <span class="no-wrap">
            <q-icon v-if="icon" :name="icon" size="xs" :class="{ 'q-mr-sm': label }" />
            <template v-if="label">
                {{ label }}
            </template>
        </span>
    </q-btn>
</template>

<script setup>
defineProps({
    label: String,
    icon: String,
    secondary: Boolean, // Indicate this is a secondary button, so make it standout less?
    to: [String, Object],
})
</script>
